export default function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    var p = el;
    while (p) {
        if (matchesSelector.call(p, selector)) {
            return p;
        }
        p = p.parentElement;
    }
    return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/_util/closest.js
// module id = 55
// module chunks = 0